import { SearchIcon, XIcon } from 'lucide-react';
import {
  SearchField as AriaSearchField,
  SearchFieldProps as AriaSearchFieldProps,
  ValidationResult
} from 'react-aria-components';
import { Button } from './Button';
import { Description, FieldError, FieldGroup, Input, Label } from './Field';
import { composeTailwindRenderProps } from '~/library/utilities';

export interface SearchFieldProps extends AriaSearchFieldProps {
  label?: string;
  description?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
}

export function SearchField(
  { label, description, errorMessage, ...props }: SearchFieldProps
) {
  return (
    <AriaSearchField {...props} className={composeTailwindRenderProps(props.className, 'u-group u-flex u-flex-col u-gap-1')}>
      {label && <Label className="u-sr-only">{label}</Label>}
      <FieldGroup className="u-border-2 u-border-pink">
        <SearchIcon aria-hidden className="u-w-8 u-h-8 u-flex-none u-z-20 u-relative u-ml-4 u-text-pink" />
        <Input className="[&::-webkit-search-cancel-button]:u-hidden focus:u-outline-none" />
        <Button variant="icon" className="u-w-8 group-empty:u-invisible u-mr-4">
          <XIcon aria-hidden className="u-w-8 u-h-8" />
        </Button>
      </FieldGroup>
      {description && <Description>{description}</Description>}
      <FieldError>{errorMessage}</FieldError>
    </AriaSearchField>
  );
}
